import { useLocation } from "react-router-dom";
import { Dashboard } from "../dashboard/Dashboard";
import { IntegrationsDashboard } from "../integrations";
import { AnalyticsView } from "../views/AnalyticsView";
import { BillingView } from "../views/BillingView";
import { DemoDeployView } from "../views/DemoDeployView";
import { DeploymentsView } from "../views/DeploymentsView";
import { MonitoringView } from "../views/MonitoringView";
import { ServicesView } from "../views/ServicesView";
import { SettingsView } from "../views/SettingsView";
import { TeamView } from "../views/TeamView";

export function MainContent() {
  const location = useLocation();
  const currentPath = location.pathname.split("/")[1];

  const renderView = () => {
    switch (currentPath) {
      case "dashboard":
        return <Dashboard />;
      case "deployments":
        return <DeploymentsView />;
      case "demo-deploy":
        return <DemoDeployView />;
      case "analytics":
        return <AnalyticsView />;
      case "services":
        return <ServicesView />;
      case "monitoring":
        return <MonitoringView />;
      case "team":
        return <TeamView />;
      case "billing":
        return <BillingView />;
      case "settings":
        return <SettingsView />;
      case "integrations":
        return <IntegrationsDashboard />;
      default:
        return <Dashboard />;
    }
  };

  return <>{renderView()}</>;
}
